import React, { useState } from "react"
import Container from "./Container"
import { motion } from "framer-motion"
import { cardVariants } from "../utils/animations"

function Tabs({ content }) {
  const [selectedTab, setSelectedTab] = useState(0)

  const tabHeight = 450 / content.tabs.length

  return (
    <Container>
      <div className="mb-[300px]">
        <div className=" flex flex-col justify-center items-center  ">
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[#4D4D4D]  text-center mb-[24px] w-full  lg:w-[50%]"
          >
            {content.secondaryTitle}
          </motion.p>
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[24px] md:text-[32px] font-[700] text-center mb-16"
          >
            {content.mainTitle}
          </motion.p>
        </div>
        <motion.div
          variants={cardVariants}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.3 }}
          className="hidden md:flex   w-full"
        >
          <div className="  p-4 w-[30%]">
            {content.tabs.map((tab, index) => (
              <div
                key={tab.name}
                onClick={() => setSelectedTab(index)}
                style={{ height: `${tabHeight}px` }}
                className={`cursor-pointer quicksand font-[500] text-[20px]  border-l-2  pl-4 ${
                  selectedTab === index
                    ? "border-[#3D41C2] text-[#3D41C2]"
                    : "border-[#D8D9F3] text-[#808080]"
                } `}
              >
                <p>{tab.name}</p>
              </div>
            ))}
          </div>
          <div className=" p-4 bg-[#ECECF9] rounded-[30px] w-[70%]">
            <div className="aspect-[725/292]  h-full w-full flex justify-center items-center">
              <img
                className=" w-full"
                src={content.tabs[selectedTab].image}
                alt=""
              />
            </div>
          </div>
        </motion.div>
        {/* small tab */}
        <div className="md:hidden flex flex-col gap-8">
          <div className="flex gap-3 overflow-auto">
            {content.tabs.map((tab, index) => (
              <div
                key={tab.name}
                onClick={() => setSelectedTab(index)}
                className={`cursor-pointer quicksand font-[500] text-[13px]  border-b-2  p-2 ${
                  selectedTab === index
                    ? "border-[#3D41C2] text-[#3D41C2]"
                    : "border-[#D8D9F3] text-[#808080]"
                } `}
              >
                <p>{tab.name}</p>
              </div>
            ))}
          </div>
          <div className="border p-8 bg-[#ECECF9] rounded-[30px] w-full">
            <div className="aspect-[725/292] w-full flex justify-center items-center">
              <img src={content.tabs[selectedTab].image} alt="" />
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Tabs
